<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {ModalWindowActions} from 'shared/modal-dialogs';
    import type {ExceptionActionResponse} from 'src/typings';
    import {ExceptionSeverity} from 'shared/constants';
    import {triggerCaptureScreenshotEvent, triggerGenerateReportEvent} from 'core/debug-util/setup';
    import KpModalContent from '../kp-modal/KpModalContent.svelte';
    import KpModalFooterCloseButton from '../kp-modal/KpModalFooterCloseButton.svelte';
    import KpModalTitle from 'src/modals/kp-modal/KpModalTitle.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import KpMarkdown from 'shared/components/kp-markdown/KpMarkdown.svelte';

    export let model: ExceptionActionResponse;
    export let modalWindowActions: ModalWindowActions;

    const localize = getLocalization();
</script>


<KpModalContent {modalWindowActions} additionalClasses="finished-response-modal">
    <svelte:fragment slot="header">
        <KpModalTitle>
            {#if model.severity === ExceptionSeverity.SEVERITY_WARNING}
                {localize(/* @kp-localization commons.warning */ 'commons.warning')}
            {:else}
                {localize(/* @kp-localization commons.chyba */ 'commons.chyba')}
            {/if}
        </KpModalTitle>
    </svelte:fragment>

    <svelte:fragment slot="body">
        {#if model.markdown}
            <KpMarkdown markdown={model.text} block/>
        {/if}
        <div class="text-center">
            {#if !model.markdown}
                <p>
                    <!-- we do not use @html (as in finished-response modal), because we can show error from e.g. external web service http call, which can contain malicious error message -->
                    <strong data-qa="exception-response-text">{model.text}</strong>
                </p>
            {/if}

            {#if model.severity === ExceptionSeverity.SEVERITY_ERROR}
                <div class="report-error-email">
                    <span>{localize(/* @kp-localization commons.ReportErrorViaEmailAt */ 'commons.ReportErrorViaEmailAt')}:</span>
                    <a href="mailto:feedback@systemist.cz">feedback@systemist.cz</a>
                </div>
                <div class="report-error-buttons">
                    <KpButton on:click={() => triggerGenerateReportEvent(model.text)}>
                        {localize(/* @kp-localization commons.GenerateBugReport */ 'commons.GenerateBugReport')}
                    </KpButton>
                    <KpButton on:click={() => triggerCaptureScreenshotEvent()}>
                        {localize(/* @kp-localization commons.CaptureScreenshot */ 'commons.CaptureScreenshot')}
                    </KpButton>
                </div>
            {/if}
        </div>
    </svelte:fragment>

    <svelte:fragment slot="footer">
        <KpModalFooterCloseButton action="acknowledge" dataQa="exception-response-close-button"/>
    </svelte:fragment>
</KpModalContent>

